import { useState } from 'react';
import useFetch from '../hooks/useFetch'
import { objectToQueryString } from '../utils';
import { apiWrapper } from './dataHookUtils'

export default () => {
  const [isLoading, setIsLoading] = useState(true)
  const [sessions, setSessions] = useState([])

  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const fetchSessions = async (filters = {}) => {
    try {
      setIsLoading(true);
      const response = await fetch(`events/event/sessions?${objectToQueryString(filters)}`, { method: 'GET' })
      const jsonData = await response.json()
      if (jsonData.error) {
        setSessions([])
      } else {
        setSessions(jsonData)
      }
     setIsLoading(false)
    } catch (e) {
      console.log(e)
      setSessions([])
      setIsLoading(false)
    }
  }

  const newSessions = async (sessionsData) => {
    return apiWrapper({
      fetch,
      url: `events/event/sessions/new`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: sessionsData })
      }
    });
  }

  const updateSessions = async (sessionsData) => {
    return apiWrapper({
      fetch,
      url: `events/event/sessions/update`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: sessionsData })
      }
    });
  }

  const deleteSessions = async (sessionsData) => {
    return apiWrapper({
      fetch,
      url: `events/event/sessions/delete`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: sessionsData })
      }
    });
  }

  const fetchModuleBlueprints = async (sessionsData) => {
    return apiWrapper({
      fetch,
      url: `events/event/session/blueprints`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchSession = async (sessionId) => {
    return apiWrapper({
      fetch,
      url: `events/event/session?id=${sessionId}`,
      options: {
        method: 'GET'
      }
    });
  }

  return {
    isLoading,
    sessions,
    fetchSessions,
    newSessions,
    updateSessions,
    deleteSessions,
    fetchModuleBlueprints,
    fetchSession
  }
}